"use strict";

var _interopRequireWildcard = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
var _interopRequireDefault = require("/Users/vagrant/git/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/es6.function.name");
var _regenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/regenerator.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/Users/vagrant/git/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _user = require("@/api/user");
var _auth = require("@/utils/auth");
var _router = _interopRequireWildcard(require("@/router"));
var _auth2 = require("../../utils/auth");
var _utils = require("@/utils");
var _apolloClient = require("@/apollo/apolloClient");
var _userQuery = require("@/apollo/queries/user-query");
// import { apolloClient } from '@/apollo/apolloClient'
// import { LOGIN } from '@/apollo/queries/user-query'

var firebase = require('firebase');
var state = {
  token: (0, _auth.getToken)(),
  name: '',
  avatar: '',
  introduction: '',
  roles: [],
  company_code: (0, _auth2.getCompanyCode)(),
  company_uid: (0, _auth2.getCompanyUID)(),
  redirect: '',
  user: [],
  zoneInfo: {}
};
var mutations = {
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_INTRODUCTION: function SET_INTRODUCTION(state, introduction) {
    state.introduction = introduction;
  },
  SET_NAME: function SET_NAME(state, name) {
    state.name = name;
  },
  SET_AVATAR: function SET_AVATAR(state, avatar) {
    state.avatar = avatar;
  },
  SET_ROLES: function SET_ROLES(state, roles) {
    state.roles = roles;
  },
  SET_COMPANY_CODE: function SET_COMPANY_CODE(state, company_code) {
    state.company_code = company_code;
  },
  SET_COMPANY_UID: function SET_COMPANY_UID(state, company_uid) {
    state.company_uid = company_uid;
  },
  SET_REDIRECT: function SET_REDIRECT(state, redirect) {
    state.redirect = redirect;
  },
  SET_FIREBASE_USER: function SET_FIREBASE_USER(state, user) {
    state.user = user;
  },
  CREATE_ZONE_INFO: function CREATE_ZONE_INFO(state, zone) {
    state.zoneInfo = zone;
  }
};
var actions = {
  // user login
  login: function () {
    var _login = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee3(_ref, userInfo) {
      var commit, id, password, loginFunctions, loginRespond;
      return (0, _regenerator2.default)().w(function (_context3) {
        while (1) switch (_context3.n) {
          case 0:
            commit = _ref.commit;
            id = userInfo.id, password = userInfo.password; // ------->ここから
            loginFunctions = firebase.app().functions('asia-northeast1');
            loginRespond = loginFunctions.httpsCallable('adminLogin');
            _context3.n = 1;
            return loginRespond({
              user_id: id,
              password: (0, _user.encrypt)(password)
            }).then(/*#__PURE__*/function () {
              var _ref2 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee2(result) {
                return (0, _regenerator2.default)().w(function (_context2) {
                  while (1) switch (_context2.n) {
                    case 0:
                      if (!(result.data.code === 200)) {
                        _context2.n = 2;
                        break;
                      }
                      _context2.n = 1;
                      return firebase.auth().setPersistence(firebase.auth.Auth.Persistence.LOCAL).then(/*#__PURE__*/(0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee() {
                        var checkClaim;
                        return (0, _regenerator2.default)().w(function (_context) {
                          while (1) switch (_context.n) {
                            case 0:
                              // check claim in token
                              checkClaim = (0, _utils.claimTokenInLogin)(result.data.login_token);
                              (0, _auth2.setClaimToken)(checkClaim);
                              if (!(checkClaim === 'no-claim')) {
                                _context.n = 1;
                                break;
                              }
                              console.log('TokenにClaimはありません');
                              return _context.a(2, Promise.reject('認証に失敗しました。'));
                            case 1:
                              _context.n = 2;
                              return firebase.auth().signInWithCustomToken(result.data.login_token).catch(function (error) {
                                return Promise.reject('認証に失敗しました。(' + error.data.code + ')');
                              });
                            case 2:
                              return _context.a(2, _context.v);
                          }
                        }, _callee);
                      }))).catch(function (error) {
                        return Promise.reject('認証に失敗しました。(' + error.code + ')');
                      });
                    case 1:
                      if (result.data.is_admin === true) {
                        // 管理者権限の場合
                        commit('SET_REDIRECT', '/company');
                        commit('SET_TOKEN', 'admin-token');
                        (0, _auth.setToken)('admin-token');
                        (0, _auth2.setCompanyCode)(result.data.company_id);
                        (0, _auth2.setCompanyUID)(result.data.uid);
                      } else {
                        // 通常ユーザーの場合
                        commit('SET_REDIRECT', '/company/edit');
                        commit('SET_TOKEN', 'editor-token');
                        (0, _auth.setToken)('editor-token');
                        (0, _auth2.setCompanyCode)(result.data.company_id);
                        (0, _auth2.setCompanyUID)(result.data.uid);
                      }
                      _context2.n = 3;
                      break;
                    case 2:
                      return _context2.a(2, Promise.reject(result.data.message));
                    case 3:
                      return _context2.a(2);
                  }
                }, _callee2);
              }));
              return function (_x3) {
                return _ref2.apply(this, arguments);
              };
            }()).catch(function (error) {
              console.log(error);
              return Promise.reject(error);
            });
          case 1:
            return _context3.a(2);
        }
      }, _callee3);
    }));
    function login(_x, _x2) {
      return _login.apply(this, arguments);
    }
    return login;
  }(),
  setFirebaseUser: function () {
    var _setFirebaseUser = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee4(_ref4, user) {
      var commit;
      return (0, _regenerator2.default)().w(function (_context4) {
        while (1) switch (_context4.n) {
          case 0:
            commit = _ref4.commit;
            commit('SET_FIREBASE_USER', user);
          case 1:
            return _context4.a(2);
        }
      }, _callee4);
    }));
    function setFirebaseUser(_x4, _x5) {
      return _setFirebaseUser.apply(this, arguments);
    }
    return setFirebaseUser;
  }(),
  // get user info
  getInfo: function getInfo(_ref5) {
    var commit = _ref5.commit,
      state = _ref5.state;
    return new Promise(function (resolve, reject) {
      (0, _user.getInfo)(state.token).then(function (response) {
        var data = response.data;
        if (!data) {
          reject('Verification failed, please Login again.');
        }
        var roles = data.roles,
          name = data.name,
          avatar = data.avatar,
          introduction = data.introduction;
        if (!roles || roles.length <= 0) {
          reject('getInfo: roles must be a non-null array!');
        }
        commit('SET_ROLES', roles);
        commit('SET_NAME', name);
        commit('SET_AVATAR', avatar);
        commit('SET_INTRODUCTION', introduction);
        resolve(data);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // user logout
  logout: function logout(_ref6) {
    var commit = _ref6.commit,
      state = _ref6.state;
    return new Promise(function (resolve, reject) {
      (0, _user.logout)(state.token).then(function () {
        commit('SET_TOKEN', '');
        commit('SET_ROLES', []);
        (0, _auth.removeSidebarStatus)();
        (0, _auth.removeSize)();
        (0, _auth.removeToken)();
        (0, _auth.removeCompanyCode)();
        (0, _auth.removePerCompanyCode)();
        (0, _auth.removeEventDetailCode)();
        (0, _auth.removePerEventCode)();
        (0, _auth.removeCouponCode)();
        (0, _auth.removeCouponCompanyCode)();
        (0, _auth.removeCouponEventCode)();
        (0, _auth.removeCouponIndexCode)();
        (0, _auth.removeCompanyUID)();
        (0, _router.resetRouter)();
        resolve();
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // remove token
  resetToken: function resetToken(_ref7) {
    var commit = _ref7.commit;
    return new Promise(function (resolve) {
      commit('SET_TOKEN', '');
      commit('SET_ROLES', []);
      (0, _auth.removeSidebarStatus)();
      (0, _auth.removeSize)();
      (0, _auth.removeToken)();
      (0, _auth.removeCompanyCode)();
      (0, _auth.removePerCompanyCode)();
      (0, _auth.removeEventDetailCode)();
      (0, _auth.removePerEventCode)();
      (0, _auth.removeCouponCode)();
      (0, _auth.removeCouponCompanyCode)();
      (0, _auth.removeCouponEventCode)();
      (0, _auth.removeCouponIndexCode)();
      (0, _auth.removeCompanyUID)();
      resolve();
    });
  },
  // dynamically modify permissions
  changeRoles: function changeRoles(_ref8, role) {
    var commit = _ref8.commit,
      dispatch = _ref8.dispatch;
    return new Promise(/*#__PURE__*/function () {
      var _ref9 = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee5(resolve) {
        var token, _yield$dispatch, roles, accessRoutes;
        return (0, _regenerator2.default)().w(function (_context5) {
          while (1) switch (_context5.n) {
            case 0:
              token = role + '-token';
              commit('SET_TOKEN', token);
              (0, _auth.setToken)(token);
              _context5.n = 1;
              return dispatch('getInfo');
            case 1:
              _yield$dispatch = _context5.v;
              roles = _yield$dispatch.roles;
              (0, _router.resetRouter)();

              // generate accessible routes map based on roles
              _context5.n = 2;
              return dispatch('permission/generateRoutes', roles, {
                root: true
              });
            case 2:
              accessRoutes = _context5.v;
              // dynamically add accessible routes
              _router.default.addRoutes(accessRoutes);

              // reset visited views and cached views
              dispatch('tagsView/delAllViews', null, {
                root: true
              });
              resolve();
            case 3:
              return _context5.a(2);
          }
        }, _callee5);
      }));
      return function (_x6) {
        return _ref9.apply(this, arguments);
      };
    }());
  },
  GET_USER_DETAIL_INFO_QUERY: function () {
    var _GET_USER_DETAIL_INFO_QUERY = (0, _asyncToGenerator2.default)(/*#__PURE__*/(0, _regenerator2.default)().m(function _callee6(_ref0, uuid) {
      var commit, res;
      return (0, _regenerator2.default)().w(function (_context6) {
        while (1) switch (_context6.n) {
          case 0:
            commit = _ref0.commit;
            _context6.n = 1;
            return _apolloClient.apolloClient.query({
              query: _userQuery.GET_USER_DETAIL_INFO,
              variables: {
                uid: uuid
              }
            });
          case 1:
            res = _context6.v;
            commit('CREATE_ZONE_INFO', res.data.user.zone);
          case 2:
            return _context6.a(2);
        }
      }, _callee6);
    }));
    function GET_USER_DETAIL_INFO_QUERY(_x7, _x8) {
      return _GET_USER_DETAIL_INFO_QUERY.apply(this, arguments);
    }
    return GET_USER_DETAIL_INFO_QUERY;
  }()
};
var _default = exports.default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};